import { AxiosError } from 'axios';

export const defaultOnError = (error: AxiosError) => {
  console.warn(error);
};
